var plugin_rtlignore_default = {
  "alignLeft": "ftxqB",
  "textWrapNowrap": "wtTJ9",
  "alignRight": "wQ--b",
  "alignCenter": "NEgOL",
  "sizeFullWidth": "hN8ml",
  "renderedInTable": "HiIeC",
  "sizeOriginal": "_8YA5l",
  "sizeContent": "pnHHu",
  "sizeSmall": "yQ5x4",
  "sizeSmallCenter": "_-77J8",
  "flex": "R-em-",
  "atomic": "cCHaL",
  "embed": "rZvT1",
  "horizontalScrollbar": "_1GZUj",
  "pluginContainerMobile": "tIs3J"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
